var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 188,
    viewBox: "0 0 196 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 188C152.124 188 196 145.915 196 94C196 42.0852 152.124 0 98 0C43.8761 0 0 42.0852 0 94C0 145.915 43.8761 188 98 188Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5323 99.239C112.35 99.239 124.362 87.3556 124.362 72.6966C124.362 58.0377 112.35 46.1543 97.5323 46.1543C82.7144 46.1543 70.7021 58.0377 70.7021 72.6966C70.7021 87.3556 82.7144 99.239 97.5323 99.239Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5304 108.09C75.317 108.114 57.3093 125.928 57.2852 147.903C57.2852 150.342 59.2914 152.327 61.7569 152.327H133.304C135.769 152.327 137.776 150.342 137.776 147.903C137.751 125.928 119.744 108.114 97.5304 108.09Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 188,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9bca46029cd548adcc146137393b7cd0.svg";
export { ForwardRef as ReactComponent };